import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/customerGoodsSource'

export function getCustomerGoodsSourceBean(querydata) {
  return request({
      url:`${BASE_REQUEST}/getCustomerGoodsSourceBean`,
      data:querydata
  })
}
export function getList(data) {
  return request({
    url: `${BASE_REQUEST}/listForShipline`,
    method: 'get',
    data
  })
}

export function delCustomerGoodsSource(
    id
) {
    return request({
        url:`${BASE_REQUEST}/delCustomerGoodsSource`,
        data:{id: id}
    })
}
export function getCustomerGoodsSource(querydata) {
    return request({
        url:`${BASE_REQUEST}/getCustomerGoodsSource`,
        data:querydata
    })
}

// export function saveCustomerGoods(
//     obj
// ) {
//     return request({
//         url:`${BASE_REQUEST}/saveCustomerGoods`,
//         data:obj
//     })
// }

export function updateCustomerGoods(
    obj
) {
    return request({
        url:`${BASE_REQUEST}/updateCustomerGoods`,
        data:obj
    })
}

export function saveCustomerGoodsAndCost(
    goodsjson
) {
    return request({
        url:`${BASE_REQUEST}/saveCustomerGoodsAndCost`,
        data:{goodsjson: goodsjson}
    })
}

export function saveCustomerGoods(
  goodsjson
) {
  return request({
    url:`${BASE_REQUEST}/saveCustomerGoods`,
    data:{goodsjson: goodsjson}
  })
}

export function shiplineAutoMatch(
    id
) {
    return request({
        url:`${BASE_REQUEST}/shiplineAutoMatch`,
        data:{goodsId: id}
    })
}

export function preStatusChange(
    id
) {
    return request({
        url:`${BASE_REQUEST}/preStatusChange`,
        data:{id: id}
    })
}

export function getCustomerGoodsNumList(inputStr) {
  return request({
    url:`${BASE_REQUEST}/getCustomerGoodsNumList`,
    data:{inputStr: inputStr}
  })
}

export function getCustomerGoodsById(id) {
  return request({
    url:`${BASE_REQUEST}/getCustomerGoodsById`,
    data:{id: id}
  })
}
export function getCustomerGoodsByCostId(id) {
  return request({
    url:`${BASE_REQUEST}/getCustomerGoodsByCostId`,
    data:{id: id}
  })
}
export function getGoodsCostByYear(query) {
  return request({
    url: `${BASE_REQUEST}/getGoodsCostByYear`,
    data:query
  })
}

export function getCustomerGoodsCostOutById(id) {
  return request({
    url:`${BASE_REQUEST}/getCustomerGoodsCostOutById`,
    data:{id: id}
  })
}
